// extracted by mini-css-extract-plugin
export var headerCell = "_4e-1";
export var loadingSpinnerContainer = "_4e-4";
export var rowWrapper = "_4e-3";
export var standaloneTable = "_4e-5";
export var table = "_4e-0";
export var white = "_4e-2";